let website = null;

export const setWebsite = (data) => {
    website = data;
};

export const getWebsite = () => {
    return website;
};
